import { c as _c } from "react/compiler-runtime";
import React from "react";
const RatingIcon = t0 => {
  const $ = _c(2);
  const {
    color: t1
  } = t0;
  const color = t1 === undefined ? "#1E5EFF" : t1;
  let t2;
  if ($[0] !== color) {
    t2 = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.61958 1.17082C7.73932 0.802295 8.26068 0.802296 8.38042 1.17082L9.70631 5.25147C9.75986 5.41628 9.91344 5.52786 10.0867 5.52786H14.3774C14.7649 5.52786 14.926 6.02371 14.6125 6.25147L11.1413 8.77345C11.0011 8.87531 10.9424 9.05586 10.996 9.22066L12.3219 13.3013C12.4416 13.6698 12.0198 13.9763 11.7063 13.7485L8.23511 11.2265C8.09492 11.1247 7.90508 11.1247 7.76489 11.2265L4.29368 13.7485C3.98019 13.9763 3.5584 13.6698 3.67814 13.3013L5.00402 9.22067C5.05757 9.05586 4.99891 8.87531 4.85872 8.77345L1.38751 6.25147C1.07402 6.02371 1.23513 5.52786 1.62262 5.52786H5.91327C6.08656 5.52786 6.24014 5.41628 6.29369 5.25147L7.61958 1.17082Z" fill={color} /></svg>;
    $[0] = color;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default RatingIcon;